import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useParams, Link } from "react-router-dom";
import LocationDetail from "./LocationDetail";
import { CircularProgress } from "@material-ui/core";
import { HiHome } from "react-icons/hi";

const StyledProgress = styled(CircularProgress)`
	color: #000000;
`;

const StyledContainer = styled.section`
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
	background-image: url("https://i.imgur.com/uCrClLo.jpg");
	a {
		position: absolute;
		color: #ffffff;
		text-decoration: none;
		z-index: 1;
		top: 10%;
		left: 10%;
	}
`;

const LocationContainer = () => {
	const [locationInfo, setLocationInfo] = useState();
	const { locationID } = useParams();
	useEffect(() => {
		const getData = async () => {
			const city = locationID.replace("%20", " ");
			let response = await fetch(
				`http://api.weatherapi.com/v1/forecast.json?key=a8373ca4b4c54ee8ad7230401220803&q=${city}&days=7&aqi=yes&alerts=no`
			);
			let data = await response.json();

			console.log(data);
			setLocationInfo(data);
		};
		getData();
	}, []);

	return (
		<StyledContainer>
			<Link to="/">
				<HiHome size={30} />
			</Link>
			{locationInfo === undefined || locationInfo.error ? (
				<StyledProgress />
			) : (
				<LocationDetail item={locationInfo} />
			)}
		</StyledContainer>
	);
};

export default LocationContainer;
